<template>
  <div class="pick-item-container">
    <component :is="Currcomp" :item="item"></component>
    <!-- <div class="radio-btn" :class="{ selected: selected }" v-show="showSelectIcon"></div> -->
  </div>
</template>

<script>
import RecycleBookList from './RecycleBookList'
import NormalList from './NormalList'

const compMap = {
  9: RecycleBookList
}
export default {
  name: 'OrderDetailInfo',
  components: {
    RecycleBookList,
    NormalList
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
    // selected: {
    //   type: Boolean,
    //   default: false
    // },
    // showSelectIcon: {
    //   type: Boolean,
    //   default: true
    // }
  },
  computed: {
    Currcomp() {
      return compMap[this.item.orderSource] || NormalList
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
